import { RootState } from '../../../app/store';

export const getBannerData = (state: RootState) => {
    return state.banner;
};